import { Box, Icon, AppBar, MenuItem, IconButton, Menu, Typography } from '@mui/material'
import { LandingButton } from 'components'
import React from 'react'
import { LogoBiosferasoftPrimary } from 'assets'
import { landingButtonPrimary, navbarDesktop, navbarMobile, navbarMenuItem } from 'styles'
import { useMarketplaceSolution } from 'hooks'
import { NAV_ITEMS_CONST } from 'const'

export const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const scrollToSection = (selector: string) => {
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' })
  }

  const { goToMarketplaceLogin } = useMarketplaceSolution()

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        boxShadow: 'none',
        color: 'white',
        px: { xs: 2, md: 5 },
        width: '100%',
      }}
    >
      {/* Desktop Navigation */}
      <Box sx={navbarDesktop}>
        <Box
          component="img"
          src={LogoBiosferasoftPrimary}
          width={{ xs: 30, md: 30, lg: 35 }}
          paddingRight={2}
        />

        {NAV_ITEMS_CONST.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => scrollToSection(item.targetIdDesktop || item.targetId || '')}
          >
            <Typography sx={navbarMenuItem}>{item.label}</Typography>
          </MenuItem>
        ))}

        <LandingButton
          text={'INICIAR SESIÓN'}
          style={{
            ...landingButtonPrimary,
            whiteSpace: 'nowrap',
            px: 1,
          }}
          onClick={goToMarketplaceLogin}
        />
      </Box>

      {/* Mobile Navigation */}
      <Box sx={navbarMobile}>
        <Box component="img" src={LogoBiosferasoftPrimary} width={'auto'} height={35} />
        <LandingButton
          text={'INICIAR SESIÓN'}
          style={{ ...landingButtonPrimary, width: '200px' }}
          onClick={goToMarketplaceLogin}
        />
        <IconButton
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          sx={{ color: 'white' }}
        >
          <Icon>menu</Icon>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{ display: { xs: 'block', md: 'none' } }}
        >
          {NAV_ITEMS_CONST.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                handleCloseNavMenu()
                scrollToSection(item.targetIdMobile || item.targetId || '')
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </AppBar>
  )
}
